import React from 'react';
import { PropTypes } from 'prop-types';
import {observer} from 'mobx-react';

@observer
export class NewAppSubmitInterstitial extends React.Component {

	static propTypes = {
		store: PropTypes.object.isRequired,
		actionText: PropTypes.string,
		buttonText: PropTypes.string
	};

	static defaultProps = {
		actionText: 'Submitting App',
		buttonText: 'Cancel Submission'
	}

	constructor(props) {
		super(props);
		this.cancelIsFocused = false;
	}

	onCancelSubmission = () => {
		this.props.store.cancelSubmission();
	};

	componentDidUpdate() {
		if(this.props.store.showLoadingOverlay) {
			this.dummyButton.focus();
			this.cancelIsFocused = false;
		}
	}

	onFocus = () => {
		this.cancelIsFocused = false;
	};

	onKeyDown = (event) => {
		if(event.keyCode == 9) {
			event.preventDefault();
			if(this.cancelIsFocused) {
				this.dummyButton.focus();
			} else {
				this.cancelButton.focus();
			}
			this.cancelIsFocused = !this.cancelIsFocused;
		}
	};

	render () {
		return(
			<div className={`new-app-submit-interstitial ${this.props.store.showLoadingOverlay ? ' show' : ''}`}>
				<h3>{this.props.actionText}...</h3>
				<p>This may take a few moments.</p>
				<div className="submit-loading-spinner">
					{new Array(8).fill('').map((elem, idx) => {return(<div key={idx}></div>)})}
				</div>
				<button
					onFocus={this.onFocus}
					onKeyDown={this.onKeyDown}
					ref={ref => {this.cancelButton = ref}}
					className="btn fn-cancel"
					onClick={this.onCancelSubmission}>{this.props.buttonText}</button>
				<button
					aria-hidden="true"
					onKeyDown={this.onKeyDown}
					className="dummy-button"
					ref={ref => {this.dummyButton = ref}}></button>
			</div>
		);
	}

}
